module.exports = __webpack_public_path__ + "408e5ff376139f9110647e3114bc9e1c.MP3";